import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import { send_request } from '../../../utils/Request';
import ConfirmDestructiveActionDialog from '../../W86Components/ConfirmDestructiveActionDialog';

function ConfirmDeleteUnsubmittedSessionsDialog({
  isOpen,
  close,
  sessionIds,
  deleteSessions,
  deleteAll = false,
}) {
  const [user, setUser] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const loadUsername = async () => {
      const json = await send_request(`authz-service/user-info`, '', {});
      if (json && json.data) setUser(json.data.displayName);
    };
    loadUsername();
  }, []);

  const sessionCount = sessionIds?.length || 0;

  return (
    <ConfirmDestructiveActionDialog
      open={isOpen}
      title={
        deleteAll
          ? 'Confirm delete all unsubmitted form sessions'
          : 'Confirm delete unsubmitted form sessions'
      }
      headerDetail={
        <>
          <strong>{user || <Skeleton variant="text" width={125} sx={{ display: 'inline-block' }} />}</strong>{' '}
          is deleting {sessionCount} unsubmitted form session{sessionCount !== 1 ? 's' : ''}
        </>
      }
      warning={
        <>
          You are about to delete {sessionCount} unsubmitted form session
          {sessionCount !== 1 ? 's' : ''}. This action cannot be undone. The form data saved in
          these sessions will be permanently removed.
        </>
      }
      confirmPhrase="delete"
      confirmLabel={`Delete ${sessionCount} Session${sessionCount !== 1 ? 's' : ''}`}
      loading={isDeleting}
      manageLoading={false}
      confirmDisabled={sessionCount === 0}
      onClose={close}
      onConfirm={async () => {
        setIsDeleting(true);
        try {
          await deleteSessions(sessionIds);
          close();
        } finally {
          setIsDeleting(false);
        }
      }}
    />
  );
}

export default ConfirmDeleteUnsubmittedSessionsDialog;
